/* eslint-disable */
export const passwordMinimumRequirementsRegex =
  '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$';
